module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 40\"><path d=\"M23 16h-3V7.5C20 5 18 3 15.5 3h-5C8 3 6 5 6 7.5V16H3V7.5C3 3.4 6.4 0 10.5 0h5C19.6 0 23 3.4 23 7.5V16z\" fill=\"#FF7500\"/><path d=\"M26 22v10c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8V22c0-2.2 1.8-4 4-4h18c2.2 0 4 1.8 4 4zm-9.5 3.5c0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5c0 1.2.6 2.2 1.5 2.9V33c0 1.1.9 2 2 2s2-.9 2-2v-4.6c.9-.7 1.5-1.7 1.5-2.9z\" fill=\"#949494\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/security.svg
// module id = 92
// module chunks = 0